/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import 'core-js/modules/es.string.replace';

const conditionClassModifier = condition => condition && condition.toLowerCase().replace(/_/g, '-');

export default conditionClassModifier;
//# sourceMappingURL=conditionClassModifier.js.map
